export default {
    filters: {
        thousands(value, sep = ',') {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep)
        },
    },
}
